import { Typography, useTheme, useMediaQuery, Box } from '@mui/material';
import AccordionSection from '../../shared/accordionSection';
import SimpleTable from '../../shared/simpleTable';
import { OrderNoteModel } from '@/app/interfaces/response/OrderDetailsResponse';
import dayjs from 'dayjs';

const TITLE_NOTES = 'Note(s)';
const HEADERS = ['Created On', 'Note'];

const Notes = ({ notes }: { notes: OrderNoteModel[] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const rows = notes.map((note) => [
    dayjs(note.createdOn).format('MM/DD/YYYY hh:mm:ss A'),
    note.note,
  ]);
  const content = (
    <Box
      mt={1.5}
      p={isMobile ? 1 : 3}
      borderRadius={2}
      boxShadow={{
        xs: '0 0px 0px rgba(0,0,0,0)',
        md: '0 1px 3px rgba(0,0,0,0.1)',
      }}
      bgcolor="white"
    >
      {!isMobile && (
        <Typography variant="subtitle1" fontWeight={600} color="text.secondary" mb={2}>
          {TITLE_NOTES}
        </Typography>
      )}
      <Box className="simpleTable">
        <SimpleTable headers={HEADERS} rows={rows} emptyText="No notes available." />
      </Box>
    </Box>
  );

  return isMobile ? <AccordionSection title={TITLE_NOTES}>{content}</AccordionSection> : content;
};

export default Notes;
